import React from "react";
import { Link } from "react-router-dom";

import circle1 from "../../images/hero/circle_engine_1.webp";
import circle2 from "../../images/hero/circle_engine_2.webp";
import circle3 from "../../images/hero/circle_engine_3.webp";
import circle4 from "../../images/hero/circle_engine_4.webp";
import shape1 from "../../images/hero/shape_image_1.webp";
import shape2 from "../../images/hero/shape_image_2.webp";
import shape3 from "../../images/hero/shape_image_3.webp";
import shape4 from "../../images/hero/shape_image_4.webp";
import Bg from "../../images/shapes/shape_title_under_line.svg";

const Hero2 = () => {
  return (
    <section className="software_company_hero_section xb-hidden">
      {/* Inline critical CSS */}
      <style>
        {`
          .heading_focus_text {
            background-image: url(${Bg});
            font-size: 1.1rem;
            letter-spacing: 1px;
            font-weight: bold;
            text-transform: uppercase;
            background-size: cover;
            background-position: center;
            padding: 0.5rem 1rem;
            margin-bottom: 1rem;
            border-radius: 5px;
          }
          .subheadline {
            font-size: 1.1rem;
            color: #D1D1D1;
            line-height: 1.5;
            margin-bottom: 1.5rem;
            font-family: Roboto, sans-serif;
          }
          .btn-custom {
            background-color: #007BFF;
            color: #fff;
            padding: 0.75rem 1.5rem;
            border-radius: 30px;
            font-size: 1rem;
            font-weight: 500;
            box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
            transition: background-color 0.3s ease;
          }
          .hotline_block {
            display: flex;
            align-items: center;
            text-decoration: none;
            color: #D1D1D1;
            font-size: 1rem;
            margin-top: 1rem;
          }
        `}
      </style>

      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="content_wrap">
              <div className="heading_focus_text has_underline text-white d-inline-flex">
                Perfect Company Solution
              </div>
                <h1 style={{ color: "white" }}>
                  <mark>Custom Software, AI</mark> & Digital Solutions for Business
                </h1>
              <p className="subheadline">
                Laskon Technologies designs and develops business software, AI solutions, cloud platforms, and secure digital products—from product strategy through delivery.
              </p>
              <ul className="step_list text-white unordered_list_block">
                <li>Prioritize quality in every detail</li>
                <li>Ensure timely market delivery</li>
              </ul>
              <ul className="btns_group unordered_list p-0 justify-content-start">
                <li>
                  <Link className="btn btn-custom" to="/contact">
                    <span className="btn_label" data-text="Contact Us Today!">
                      Contact Us Today!
                    </span>
                    <span className="btn_icon">
                      <i className="fa-solid fa-arrow-up-right"></i>
                    </span>
                  </Link>
                </li>
                <li>
                  <a className="hotline_block" href="tel:+44 7466 436417">
                    <span className="hotline_icon">
                      <i className="fa-solid fa-phone-volume"></i>
                    </span>
                    <span className="hotline_content">
                      <small>CALL US TODAY</small>
                      <strong className="text-white">+44 7466 436417</strong>
                    </span>
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="col-lg-6 d-none d-md-block">
            <div className="engine_image">
              <div className="image_wrap_1">
                <img src={circle1} alt="Engine" loading="lazy" decoding="async" />
              </div>
              <div className="image_wrap_2">
                <img src={circle2} alt="Engine" loading="lazy" decoding="async" />
              </div>
              <div className="image_wrap_3">
                <img src={circle3} alt="Engine" loading="lazy" decoding="async" />
              </div>
              <div className="image_wrap_4">
                <img src={circle4} alt="Engine" loading="lazy" decoding="async" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="shape_image_1">
        <img src={shape1} alt="Decoration" loading="lazy" decoding="async" />
      </div>
      <div className="shape_image_2">
        <img src={shape2} alt="Decoration" loading="lazy" decoding="async" />
      </div>
      <div className="shape_image_3">
        <img src={shape3} alt="Decoration" loading="lazy" decoding="async" />
      </div>
      <div className="shape_image_4">
        <img src={shape4} alt="Decoration" loading="lazy" decoding="async" />
      </div>
    </section>
  );
};

export default Hero2;

// import React from "react";
// import circle1 from "../../images/hero/circle_engine_1.webp";
// import circle2 from "../../images/hero/circle_engine_2.webp";
// import circle3 from "../../images/hero/circle_engine_3.webp";
// import circle4 from "../../images/hero/circle_engine_4.webp";
// import shape1 from "../../images/hero/shape_image_1.webp";
// import shape2 from "../../images/hero/shape_image_2.webp";
// import shape3 from "../../images/hero/shape_image_3.webp";
// import shape4 from "../../images/hero/shape_image_4.webp";
// import {
//   subheadlineStyle,
//   buttonStyle,
//   headingFocusTextStyle,
//   hotlineStyle,
// } from "./styles";
// import {Link} from "react-router-dom";

// const Hero2 = (props) => {

//   return (
//     <section className="software_company_hero_section xb-hidden">
//       <div className="container">
//         <div className="row align-items-center">
//           <div className="col-lg-6">
//             <div className="content_wrap">
//               <div
//                 className="heading_focus_text has_underline text-white d-inline-flex "
//                 style={headingFocusTextStyle}
//               >
//                 Perfect Company Solution
//               </div>
//               <h1 style={{color: "white",}}>
//                 <mark>Revolutionizing</mark> Industries with{" "}
//                 <mark>Cutting-Edge</mark> Software Solutions
//               </h1>
//               <p style={subheadlineStyle}>
//                 Harnessing Advanced Technology: A Vital Step Towards Thriving in
//                 Business!
//               </p>
//               <ul className="step_list text-white unordered_list_block">
//                 <li>Prioritize quality in every detail</li>
//                 <li>Ensure timely market delivery
//                 </li>
//               </ul>
//               <ul className="btns_group unordered_list p-0 justify-content-start">
//                 <li>
//                   <Link className="btn" to="/contact" style={buttonStyle}>
//                     <span className="btn_label" data-text="Contact Us Today!">
//                       Contact Us Today!
//                     </span>
//                     <span className="btn_icon">
//                       <i className="fa-solid fa-arrow-up-right"></i>
//                     </span>
//                   </Link>
//                 </li>
//                 <li>
//                   <a
//                     className="hotline_block"
//                     href="tel:+44 7577 541394"
//                     style={hotlineStyle}
//                   >
//                     <span className="hotline_icon">
//                       <i className="fa-solid fa-phone-volume"></i>
//                     </span>
//                     <span className="hotline_content">
//                       <small>CALL US TODAY</small>
//                       <strong className="text-white">+44 7577 541394</strong>
//                     </span>
//                   </a>
//                 </li>
//               </ul>
//             </div>
//           </div>

//           <div className="col-lg-6 d-none d-md-block">
//           <div className="engine_image">
//               <div className="image_wrap_1">
//                 <img src={circle1} alt="Engine" loading="lazy" decoding="async" />
//               </div>
//               <div className="image_wrap_2">
//                 <img src={circle2} alt="Engine" loading="lazy" decoding="async" />
//               </div>
//               <div className="image_wrap_3">
//                 <img src={circle3} alt="Engine" loading="lazy" decoding="async" />
//               </div>
//               <div className="image_wrap_4">
//                 <img src={circle4} alt="Engine"  decoding="async"   loading="lazy"  />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div className="shape_image_1">
//         <img src={shape1} alt="Engine" />
//       </div>
//       <div className="shape_image_2">
//         <img src={shape2} alt="Engine" />
//       </div>
//       <div className="shape_image_3">
//         <img src={shape3} alt="Engine" />
//       </div>
//       <div className="shape_image_4">
//         <img src={shape4} alt="Engine" />
//       </div>
//     </section>
//   );
// };

// export default Hero2;
